/**
 * (c) 2022, Micro:bit Educational Foundation and contributors
 *
 * SPDX-License-Identifier: MIT
 */

export const widthToHideSidebar = 1365;
export const sidebarToWidthRatio = 0.27;
export const simulatorToWidthRatio = 0.29;
export const hideSidebarMediaQuery = `(max-width: ${widthToHideSidebar}px)`;
